import { PaysafeField } from './paysafe-field.interface';
import { PaysafeFormField } from './paysafe-form-field.enum';

export type PaysafeFields = Record<PaysafeFormField, PaysafeField>;
